module.exports = {
  platform: 'voice',
  name: 'gen_ai',
  node: 'gen_ai',
  bg: '#FFFFFF',
  note: '',
  property: {
    gen_ai: '',
    message: '',
    remember_last: 10,
    setting: {
      timeout: '10.0'
    }
  }
}
